import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation, BrowserRouter, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./component/fontawesome/css/all.min.css"
import "./app.css"
import Login from "./pages/login/login";
import Leftmenu from "./leftmenu/leftmenu";
import Home from "./pages/home/home";
import Finance from "./pages/finance/finance";
import FinanceDetails from "./pages/financeDetails/financeDetails";
import Arrivals from "./pages/arrivals/arrivals";
import Kassa from "./pages/kassa/kassa";
import Expenses from "./pages/expenses/expenses";
import QuickActions from "./pages/quickActions/quickActions";
import Reports from "./pages/reports/reports";
import Operations from "./pages/operations/operations";
import Products from "./pages/products/products";
import Transports from "./pages/transports/transports";
const API_URL = process.env.REACT_APP_API_URL;

const hasFinanceAccess = (user) => {
    if (!user) return false;
    const role = (user.role || "").trim().toLowerCase();
    const subroles = (user.subroles || []).map((r) => r.trim().toLowerCase());
    return role === "admin" || subroles.includes("finance") || subroles.includes("finance_transfers_only");
};

// Урезанный доступ: видит только /finance/transfers, всё остальное закрыто
const isTransfersOnly = (user) => {
    if (!user) return false;
    const role = (user.role || "").trim().toLowerCase();
    if (role === "admin") return false; // админу ограничение не действует
    const subroles = (user.subroles || []).map((r) => r.trim().toLowerCase());
    return subroles.includes("finance_transfers_only") && !subroles.includes("finance");
};

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};
const App = () => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }

        setLoading(false);
    }, []);
    const logout = () => {
        localStorage.removeItem("user");
        setUser(null);
    }
    if (loading) return null;

    if (user && !hasFinanceAccess(user)) {
        return (
            <div style={{ padding: 60, textAlign: "center", fontFamily: "sans-serif" }}>
                <h2 style={{ marginBottom: 16 }}>Нет доступа к сайту финансов 🚫</h2>
                <p style={{ color: "#8890A0", marginBottom: 24 }}>
                    Этот раздел доступен только администраторам и сотрудникам с ролью «Финансист».
                </p>
                <button
                    onClick={logout}
                    style={{ padding: "10px 20px", borderRadius: 10, border: "none", background: "#341F47", color: "#fff", cursor: "pointer" }}
                >
                    Выйти
                </button>
            </div>
        );
    }

    const restricted = user && isTransfersOnly(user);

    return (
        <>
            <ScrollToTop />
            <ToastContainer
                position="top-left"
                autoClose={2000}
                hideProgressBar={false}
                closeOnClick
            />
            <section className="app-screen">
                {user && <Leftmenu user={user} logout={logout} />}
                <Routes>
                    <Route
                        path="*"
                        element={
                            !user ? <Navigate to="/" />
                                : restricted ? <Navigate to="/finance/transfers" />
                                    : <Navigate to="/home" />
                        }
                    />

                    <Route
                        path="/"
                        element={
                            user
                                ? <Navigate to={restricted ? "/finance/transfers" : "/home"} />
                                : <Login setUser={setUser} API_URL={API_URL} />
                        }
                    />
                    <Route
                        path="/home"
                        element={
                            !user ? <Navigate to="/" />
                                : restricted ? <Navigate to="/finance/transfers" />
                                    : <Home setUser={setUser} API_URL={API_URL} />
                        }
                    />
                    <Route
                        path="/finance/*"
                        element={
                            user
                                ? <Finance user={user} API_URL={API_URL} restrictedToTransfers={restricted} />
                                : <Navigate to="/" />
                        }
                    />
                    <Route
                        path="/financedetails/:requestType/:orderNumber"
                        element={
                            !user ? <Navigate to="/" />
                                : restricted ? <Navigate to="/finance/transfers" />
                                    : <FinanceDetails user={user} API_URL={API_URL} />
                        }
                    />
                    <Route
                        path="/arrivals"
                        element={
                            !user ? <Navigate to="/" />
                                : restricted ? <Navigate to="/finance/transfers" />
                                    : <Arrivals API_URL={API_URL} />
                        }
                    />
                    <Route
                        path="/expend"
                        element={
                            !user ? <Navigate to="/" />
                                : restricted ? <Navigate to="/finance/transfers" />
                                    : <Expenses API_URL={API_URL} />
                        }
                    />
                    <Route
                        path="/expend/kassa"
                        element={
                            !user ? <Navigate to="/" />
                                : restricted ? <Navigate to="/finance/transfers" />
                                    : <Kassa API_URL={API_URL} />
                        }
                    />
                    <Route
                        path="/reports"
                        element={
                            !user ? <Navigate to="/" />
                                : restricted ? <Navigate to="/finance/transfers" />
                                    : <Reports API_URL={API_URL} />
                        }
                    />
                    <Route
                        path="/operations"
                        element={
                            !user ? <Navigate to="/" />
                                : restricted ? <Navigate to="/finance/transfers" />
                                    : <Operations API_URL={API_URL} />
                        }
                    />
                    <Route
                        path="/products"
                        element={
                            !user ? <Navigate to="/" />
                                : restricted ? <Navigate to="/finance/transfers" />
                                    : <Products API_URL={API_URL} />
                        }
                    />
                    <Route
                        path="/transports"
                        element={
                            !user ? <Navigate to="/" />
                                : restricted ? <Navigate to="/finance/transfers" />
                                    : <Transports API_URL={API_URL} />
                        }
                    />
                </Routes>
                {user && <QuickActions API_URL={API_URL} />}
            </section>
        </>
    )
}
export default App;